export default {
  CREDIT_CARD: 'creditCard',
  PAYPAL: 'payPal',
  GIFT_OPTIONS: 'giftOptions',
  SAVED_CREDIT_CARD: 'savedCreditCard',
  SAVED_PAYMENT_CARD: 'savedPaymentCard',
  TOKENIZED_PAYMENT_CARD: 'tokenizedPaymentCard',
  POS_PAYMENT_CARD: 'posPaymentCard',
  GIFT_CARD: 'giftCard',
  GIFT_VOUCHER: 'giftVoucher',
  PROMO_CODE: 'promoCode',
  PACT: 'PACT',
  APPLE_PAY: 'applePay',
  APPLE_PAY_EXPRESS: 'applePayExpress',
  POS_CREDIT: 'posCredit',
  GOOGLE_PAY: 'googlePay',
};
